/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 *
 * Distributor progress (item 232) — the index of distributors, and one
 * distributor's read-only progress view. Both hang off the same component; the
 * `distributor` route param decides which.
 *
 * The static `/incentives/progress` segment outranks the `/incentives/:programId`
 * pattern in React Router's route ranking, so this cannot be swallowed by the
 * program route.
 */
import { useNavigate, useParams } from "react-router-dom";
import DistributorProgressPage from "../components/DistributorProgressPage.jsx";

export default function IncentiveDistributorProgress() {
  const navigate = useNavigate();
  const { distributor } = useParams();
  const name = distributor ? decodeURIComponent(distributor) : null;
  return (
    <DistributorProgressPage
      distributor={name}
      onBack={() => navigate(name ? "/incentives/progress" : "/incentives")}
      onHome={() => navigate("/")}
      onOpenDistributor={(d) => navigate(`/incentives/progress/${encodeURIComponent(d)}`)}
    />
  );
}
